(() => {
  if (window.dsAnkleSelectionMedia) return;
  window.dsAnkleSelectionMedia = true;
  const initialized = new WeakSet();
  const attributes = ['src', 'srcset', 'alt', 'width', 'height'];
  const snapshot = (element, names) => Object.fromEntries(names.map(name => [name, element.getAttribute(name)]));
  const apply = (element, values) => Object.entries(values).forEach(([name, value]) => {
    if (value === null) element.removeAttribute(name);
    else element.setAttribute(name, value);
  });
  function initialize() {
    document.querySelectorAll('[data-ankle-selection-media]').forEach(template => {
      if (initialized.has(template)) return;
      const section = template.closest('product-info');
      const picker = section?.querySelector('.ds-ankle-picker');
      const gallery = section?.querySelector('media-gallery');
      const slide = gallery?.querySelector('.product__media-list > [data-media-id]');
      const hero = slide?.querySelector('.product__media img');
      const bundle = template.content.querySelector('img');
      if (!picker || !hero || !bundle) return;
      initialized.add(template);
      const thumbnail = gallery.querySelector(`[data-target="${slide.dataset.mediaId}"] img`);
      const images = [hero, thumbnail].filter(Boolean).map(element => ({element, original: snapshot(element, attributes)}));
      const opener = slide.querySelector('.product__modal-opener--image');
      const originalZoom = opener && snapshot(opener, ['href', 'data-pswp-width', 'data-pswp-height']);
      const bundleImage = snapshot(bundle, attributes);
      const bundleZoom = {href: template.dataset.fullSrc, 'data-pswp-width': template.dataset.fullWidth, 'data-pswp-height': template.dataset.fullHeight};
      let selected = 'single';
      function update() {
        const next = picker.querySelector('[name="ds_set"]:checked')?.value;
        if (!next || next === selected) return;
        selected = next;
        images.forEach(({element, original}) => apply(element, next === 'core' ? bundleImage : original));
        if (opener) apply(opener, next === 'core' ? bundleZoom : originalZoom);
        // Select the leading photo without taking focus or scrolling away from purchase controls.
        gallery.setActiveMedia?.(slide.dataset.mediaId, false, false);
        if (matchMedia('(max-width: 749px)').matches) slide.parentElement.scrollTo({left: 0, behavior: 'instant'});
      }
      picker.addEventListener('change', event => {
        if (event.target.name === 'ds_set') update();
      });
      update();
      template.dataset.ready = 'true';
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
